var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCheckPointLocked(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 20,
    viewBox: "0 0 18 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1 10.9999C1 9.1139 1 8.17189 1.58601 7.58589C2.17201 6.99988 3.11402 6.99988 5.00005 6.99988H13.0001C14.8862 6.99988 15.8282 6.99988 16.4142 7.58589C17.0002 8.17189 17.0002 9.1139 17.0002 10.9999V12.9999C17.0002 15.828 17.0002 17.243 16.1212 18.121C15.2432 19 13.8281 19 11.0001 19H7.00007C4.17204 19 2.75702 19 1.87901 18.121C1 17.243 1 15.828 1 12.9999V10.9999Z",
    stroke: "#121212",
    strokeWidth: 1.8
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.0001 6.00006V5.00005C13.0001 3.93917 12.5787 2.92174 11.8285 2.17159C11.0784 1.42143 10.0609 1 9.00005 1C7.93917 1 6.92174 1.42143 6.17159 2.17159C5.42143 2.92174 5 3.93917 5 5.00005V6.00006",
    stroke: "#121212",
    strokeWidth: 1.8,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9.00002 15.0003C10.1046 15.0003 11 14.1049 11 13.0003C11 11.8957 10.1046 11.0002 9.00002 11.0002C7.89544 11.0002 7 11.8957 7 13.0003C7 14.1049 7.89544 15.0003 9.00002 15.0003Z",
    fill: "#121212"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckPointLocked);
export default __webpack_public_path__ + "static/media/check_point_locked.f7ca0843791818b7594e766fd574d820.svg";
export { ForwardRef as ReactComponent };